import { fire } from "./fire"
let fireLevel = 20

export const raise = (ticker: any,) => {
    const raiseFire = () => {
        if (fireLevel <= 22) {
            fireLevel++
        }
        fire.y = 10 + fireLevel
        if (fireLevel > 22) {
            ticker.remove(raiseFire, 'raiseFire')
        }
    }
    ticker.add(raiseFire, 'raiseFire')
}


export const stopFire = () => {
    fire.y = 10
    fireLevel = 0
}